import { SaleDTO, TicketDTO, TicketLineDTO } from 'core/api';
import { Display } from './Display';

const display: Display = {

	async clear(): Promise<void> {

	},

	async displayTotal(_amount: number): Promise<void> {

	},

	async displayTicketTotal(_ticket: TicketDTO): Promise<void> {

	},

	async displayOffers(_ticket: TicketDTO): Promise<void> {

	},

	async displaySale(_sale: SaleDTO): Promise<void> {

	},

	async displayNewLine(_ticket: TicketDTO, _line: TicketLineDTO): Promise<void> {

	},

	async displayExistingLine(_ticket: TicketDTO, _line: TicketLineDTO): Promise<void> {

	},

	async displayRemovedLine(_ticket: TicketDTO, _line: TicketLineDTO): Promise<void> {

	},

	async displayLineDiscountPercentage(_ticket: TicketDTO, _line: TicketLineDTO): Promise<void> {

	},

	async displayLineCashDiscount(_ticket: TicketDTO, _line: TicketLineDTO): Promise<void> {

	},

	async displayDiscounts(_ticket: TicketDTO): Promise<void> {

	},

	async displayClosedCashdrawer(): Promise<void> {

	},

	async displayLineNote(_ticket: TicketDTO, _line: TicketLineDTO): Promise<void> {

	},

	async displayWeight(_kgs: number, _pricePerKgs: number, _total: number): Promise<void> {

	},

	async displayCustomer(_ticket: TicketDTO): Promise<void> {

	},

	async displayPriceList(_ticket: TicketDTO): Promise<void> {

	},

	async displayServiceCharge(_ticket: TicketDTO): Promise<void> {

	}
};

export default display;